import { ReactNode } from "react";

export interface IProsp {
  title: string;
  hidden?: boolean;
  theadHidden?: boolean;
  children: ReactNode;
  styles?: string;
}
export default function TableRow({
  title,
  hidden,
  theadHidden = false,
  styles = "",
  children,
}: IProsp) {
  return (
    <tr hidden={hidden} className={styles}>
      <th hidden={theadHidden}>{title}</th>
      <td>{children}</td>
    </tr>
  );
}
